export default "\n\n\n<!-- <ion-router-outlet></ion-router-outlet> -->\n\n<!-- <app-tabs-menu></app-tabs-menu> -->";